export default "__VITE_ASSET__Ch02HQNo__"